module.exports = __webpack_public_path__ + "img/title-5.10974916.png";